import React, { useState } from 'react'
import { InjuryBtn, InjuryPopper, Status } from './styles'
import { PlayerDataGQL } from '../../../../Api'
import { Desc } from '../../../../Components/Typography/Text.styles'
import { Popper } from '../../../../Components/LazyComponents'
type InjuryProps = {
  player?: PlayerDataGQL
  withPopper?: boolean
}

export const Injury: React.FC<React.PropsWithChildren<InjuryProps>> = ({
  player,
  withPopper = true,
}) => {
  const injStatus = player?.currentTeam?.injuryStatus
    ? player.currentTeam?.injuryStatus.toLowerCase()
    : 'h'
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const id = open ? 'simple-popper' : undefined

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (!withPopper) {
      return
    }
    setAnchorEl(anchorEl ? null : event.currentTarget)
  }

  return (
    <>
      {player?.currentTeam?.injuryStatus &&
        player.currentTeam.injuryStatus.toLowerCase() !== 'h' && (
          <>
            <InjuryBtn aria-describedby={id} type="button" onClick={handleClick}>
              <Status status={injStatus}>{player.currentTeam.injuryStatus}</Status>
            </InjuryBtn>
            <Popper id={id} open={open} anchorEl={anchorEl} placement="right">
              <InjuryPopper>
                <div className="closeCon">
                  <div className="title">Description</div>
                  <div className="close" onClick={handleClick}>
                    X
                  </div>
                </div>
                <Desc vertMargins={2} sideMargins={1}>
                  {player.currentTeam.injuryDescription || 'No injury description yet.'}
                </Desc>
              </InjuryPopper>
            </Popper>
          </>
        )}
    </>
  )
}
